export const CHANGE_COLORS = 'CHANGE_COLORS'
export const changeColors = colors => ({ type: CHANGE_COLORS, colors })